import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticFooter {
  constructor(section) {
    const currencyDisclosureEl = section.el.querySelector('[data-disclosure-currency]');
    const localeDisclosureEl = section.el.querySelector('[data-disclosure-locale]');

    if (currencyDisclosureEl) {
      this.currencyDisclosure = new Disclosure(currencyDisclosureEl);
    }

    if (localeDisclosureEl) {
      this.localeDisclosure = new Disclosure(localeDisclosureEl);
    }
  }

  onSectionUnload() {
    if (this.currencyDisclosure) {
      this.currencyDisclosure.unload();
    }

    if (this.localeDisclosure) {
      this.localeDisclosure.unload();
    }
  }
}
